import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from './en.json'
import it from './it.json'

export const resources = {
  it: { translation: it },
  en: { translation: en },
} as const

const detectionOptions = {
  order: ['localStorage'],
  lookupLocalStorage: 'cef-product:lng',
  caches: ['localStorage'],
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: detectionOptions,
    resources,
    fallbackLng: 'it',
    supportedLngs: ['en', 'it'],
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false,
    },
  })
